// prettier-ignore
export class BridgeError extends Error {
    code;
    constructor(code) {
        super(code);
        this.code = code;
        this.name = 'BridgeError';
    }
}
//# sourceMappingURL=errors.js.map